import EdgeWithButtons from './EdgeWithButtons';

export default EdgeWithButtons;
